var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMontenegro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 39.9999C31.0455 39.9999 39.9998 31.0456 39.9998 19.9999C39.9998 8.95424 31.0455 -6.10352e-05 19.9998 -6.10352e-05C8.95412 -6.10352e-05 -0.000183105 8.95424 -0.000183105 19.9999C-0.000183105 31.0456 8.95412 39.9999 19.9998 39.9999Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 13.1358 36.5415 7.08007 31.2724 3.47827H8.72758C3.45859 7.08007 0 13.1358 0 20C0 26.8643 3.45859 32.9199 8.72758 36.5217H31.2724C36.5415 32.9199 40 26.8643 40 20Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6523 14.7825H24.348V11.3043L22.6088 12.1739L20.0002 9.56519L17.3915 12.1739L15.6523 11.3043V14.7825Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8262 19.9999H23.4801C23.6505 19.7051 23.7496 19.3639 23.7496 18.9989C23.7496 17.8905 22.8511 16.9922 21.7429 16.9922C20.9772 16.9922 20.3122 17.4212 19.9738 18.0517C19.6355 17.4212 18.9705 16.9922 18.2047 16.9922C17.0965 16.9922 16.198 17.8905 16.198 18.9989C16.198 19.364 16.2972 19.7052 16.4676 19.9999H12.1739C12.1739 21.3298 13.3322 22.4079 14.6621 22.4079H14.5819C14.5819 23.4987 15.3075 24.4198 16.3022 24.7157L14.3478 26.6703L16.1924 28.5149L18.809 25.8983C18.9115 25.9359 19.0176 25.9659 19.1272 25.9865L17.5461 29.5564C18.3037 29.8645 19.1318 30.0355 20.0001 30.0355C20.8684 30.0355 21.6965 29.8645 22.4542 29.5564L20.8731 25.9865C20.9826 25.9659 21.0887 25.9359 21.1911 25.8983L23.8077 28.5149L25.6522 26.6703L23.6977 24.7158C24.6924 24.4198 25.418 23.4988 25.418 22.408H25.3378C26.6678 22.4079 27.8262 21.3298 27.8262 19.9999V19.9999Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 21.3044L17.1738 22.6087V25.2174L19.9999 26.9565L22.826 25.2174V22.6087L19.9999 21.3044Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1738 19.9999H22.826V23.4782H17.1738V19.9999Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMontenegro);
export default __webpack_public_path__ + "static/media/montenegro.bbe3978a84ef1fda71d8623cb43c47a4.svg";
export { ForwardRef as ReactComponent };